import {reducer} from '../helpers'

import * as showroomsSearchActions from '../../actions/showrooms/search'
import {ApiRequestStates} from '../../const'

const initialState = {
  error: null,
  showroomLocations: [],
  fetchShowroomLocationsStatus: ApiRequestStates.IDLE,
  showTbtAndNordstromLocations: true,
  showDavidsBridalLocations: true,
}

export default reducer(initialState, (state, {payload, type}) => {
  switch (type) {
    case showroomsSearchActions.GET_LOCATIONS_BY_ZIP_RADIUS:
      // We want to preserve the user's filter selections when they perform a new search,
      // so we don't reset the filters to the initial state.
      return {
        ...initialState,
        showTbtAndNordstromLocations: state.showTbtAndNordstromLocations,
        showDavidsBridalLocations: state.showDavidsBridalLocations,
      }
    case showroomsSearchActions.GET_LOCATIONS_BY_ZIP_RADIUS_PENDING:
      return {
        error: null,
        fetchShowroomLocationsStatus: ApiRequestStates.PENDING,
      }
    case showroomsSearchActions.GET_LOCATIONS_BY_ZIP_RADIUS_SUCCESS:
      return {
        error: null,
        showroomLocations: payload,
        fetchShowroomLocationsStatus: ApiRequestStates.SUCCESS,
      }
    case showroomsSearchActions.GET_LOCATIONS_BY_ZIP_RADIUS_FAILURE:
      return {
        error: payload,
        fetchShowroomLocationsStatus: ApiRequestStates.ERROR,
      }
    case showroomsSearchActions.TOGGLE_LOCATIONS_TBT_NORDSTROM_FILTER:
      return {
        showTbtAndNordstromLocations: !state.showTbtAndNordstromLocations,
      }
    case showroomsSearchActions.TOGGLE_LOCATIONS_DAVIDS_BRIDAL_FILTER:
      return {
        showDavidsBridalLocations: !state.showDavidsBridalLocations,
      }
    default:
      return null
  }
})
